import * as React from 'react';
import { FieldRenderProps } from 'react-final-form';
import { Field } from '../Field';
import { FormItem } from './FormItem';
import { VFFieldProps } from '../types';
import { NumberInput } from '../../number/NumberInput';
import { DATA_FORM_INPUT } from '../../common/data';

export type NumberProps = VFFieldProps<
  React.ComponentProps<typeof NumberInput>
>;
export const Number = React.forwardRef<HTMLInputElement, NumberProps>(
  (
    {
      name,
      inlineValidation,
      validate,
      className,
      inputClassName,
      label,
      required,
      disabled,
      readOnly,
      validateWarning,
      ...other
    },
    ref
  ) => {
    return (
      <FormItem
        name={name}
        inlineValidation={inlineValidation}
        className={className}
        label={label}
        required={required}
        disabled={disabled}
        readOnly={readOnly}
        validateWarning={validateWarning}
      >
        <Field name={name} validate={validate}>
          {({
            input: { value, onChange, onBlur, name, ...nother },
            meta,
          }: FieldRenderProps<number>) => {
            return (
              <NumberInput
                {...DATA_FORM_INPUT(name)}
                className={inputClassName}
                // @ts-ignore
                ref={ref}
                {...nother}
                // @ts-ignore
                name={name}
                {...other}
                disabled={disabled || meta.submitting}
                readOnly={readOnly}
                value={value}
                onChange={(newValue) => {
                  const e = { target: { name, value: newValue } };
                  onChange(e);
                  other?.onChange?.(e);
                }}
                onBlur={(newValue: any) => {
                  const e = {
                    target: { name, value: newValue },
                  } as any as React.FocusEvent<HTMLElement>;
                  onBlur(e);
                  other?.onBlur?.(e);
                }}
              />
            );
          }}
        </Field>
      </FormItem>
    );
  }
);
